import React from 'react';
import { Box, Container, Divider, Grid, Stack, Typography, Link } from '@mui/material';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box className="footer" sx={{ bgcolor: '#172126', color: 'white', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="xl" sx={{ flexGrow: 1, py: { xs: 5, md: 7 } }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
              <Box component="img" src="/logo192.png" alt="FEMORPH logo" sx={{ width: 42, height: 42 }} />
              <Box>
                <Typography variant="h6" sx={{ lineHeight: 1 }}>FEMORPH</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.68)' }}>Software Portal</Typography>
              </Box>
            </Stack>
            <Typography variant="body2" sx={{ maxWidth: 420, color: 'rgba(255,255,255,0.72)', lineHeight: 1.7 }}>
              Mesh morphing software for turning as-manufactured geometry into precise finite element models.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
              <Link href="mailto:contact@advanced-engineering-analysis.com" color="inherit" target="_blank" rel="noopener noreferrer" underline="hover" sx={{ display: 'block', mb: 1 }}>
                contact@advanced-engineering-analysis.com
              </Link>
            <Typography variant="body1">+1 (303) 564-5096</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>
              Company
            </Typography>
            <Link href="/about-us" underline="hover" variant="body1" color="inherit" sx={{ display: 'block', mb: 1 }}>
              About Us
            </Link>
              <Link href="mailto:contact@advanced-engineering-analysis.com" color="inherit" target="_blank" rel="noopener noreferrer" underline="hover">
                Request a Demo
              </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>
              Legal
            </Typography>
            <Link href="/sla" underline="hover" variant="body1" color="inherit" sx={{ display: 'block', mb: 1 }}>
              SLA (Software License Agreement)
            </Link>
          </Grid>
        </Grid>
      </Container>
      <Divider sx={{ borderColor: 'rgba(255,255,255,0.14)' }} />
      <Box sx={{ py: 2, px: { xs: 2, md: 4 }, textAlign: 'left' }}>
        <Container maxWidth="xl" disableGutters>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.68)' }}>© {currentYear} Advanced Engineering Analysis LLC</Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
